import axios from "axios";

// API base URL
// const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api/demo";
const API_BASE_URL = "http://localhost:3000/api/demo";

/**
 * Verify a Google OAuth token with your backend
 * @param {Object} googleData - The Google authentication data
 * @returns {Promise<Object>} - Promise that resolves to the verification result
 */
export const authenticateWithGoogle = async googleData => {
  console.log("googleData >>>", googleData);
  try {
    const response = await axios.post(
      `${API_BASE_URL}/google-login`,
      googleData,
    );
    return response.data;
  } catch (error) {
    console.log("auth error >>>", error);
    // Properly handle different error responses
    if (error.response && error.response.data) {
      return {
        success: false,
        approved: false,
        message: error.response.data.error.message || "Authentication failed",
      };
    }

    console.error("Error authenticating with Google:", error);
    throw error;
  }
};

/**
 * Refresh the access token using the refresh token
 * @param {string} refreshToken - The refresh token
 * @returns {Promise<Object>} - Promise with new tokens
 */
export const refreshAccessToken = async refreshToken => {
  try {
    const response = await axios.post(`${API_BASE_URL}/refresh-token`, {
      refreshToken,
    });
    return response.data;
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error;
  }
};

/**
 * Process Google authentication data from credential response
 * @param {Object} credentialResponse - Response from Google authentication
 * @param {Object} additionalData - Additional user data like company and phone
 * @returns {Promise<Object>} - Processed authentication result
 */
export const processGoogleCredential = async (
  credentialResponse,
  additionalData = {},
) => {
  try {
    // For a complete implementation, you would decode the JWT here
    // For demo purposes, we'll use a simplified approach
    const token = credentialResponse.credential;

    // This is a simplified way to extract info from the token
    // In production, you should use a proper JWT decoding library
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(window.atob(base64));

    // Extract relevant information from the token
    const googleData = {
      googleId: payload.sub,
      email: payload.email,
      name: payload.name,
      picture: payload.picture,
      // Include additional data provided by user
      company: additionalData.company || "",
      phone: additionalData.phone || "",
      requestType: additionalData.requestType || "both",
    };

    // Make the API call
    return await authenticateWithGoogle(googleData);
  } catch (error) {
    console.error("Error processing Google credential:", error);
    return {
      success: false,
      message: "Failed to process Google authentication",
    };
  }
};

/**
 * Check if a user has been approved by admin
 * @param {string} email - User's email from Google auth
 * @returns {Promise<boolean>} - Promise that resolves to approval status
 */
export const checkUserApproval = async email => {
  try {
    // In a real implementation, you would call your backend
    // const response = await axios.post('/api/auth/check-approval', { email });
    // return response.data.approved;

    // Mock response for demo - you can change this to test the pending approval flow
    return true;
  } catch (error) {
    console.error("Error checking user approval:", error);
    throw error;
  }
};
